module.exports = __webpack_public_path__ + "img/微信图片_20250704112540.51203130.png";